module.exports = __webpack_public_path__ + "static/media/en.1ad736b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/localised-handheld-phones/en.png
// module id = 279
// module chunks = 0